webpackJsonp([202628748432515],{

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.JobPageQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _components = __webpack_require__(45);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _jobComponent = __webpack_require__(227);
	
	var _jobComponent2 = _interopRequireDefault(_jobComponent);
	
	var _linkBack = __webpack_require__(97);
	
	var _linkBack2 = _interopRequireDefault(_linkBack);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JobPage = function (_PureComponent) {
	  _inherits(JobPage, _PureComponent);
	
	  function JobPage(props) {
	    _classCallCheck(this, JobPage);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));
	
	    _this.state = {
	      jobSlug: null
	    };
	
	    _this.renderComponents = _this.renderComponents.bind(_this);
	    return _this;
	  }
	
	  JobPage.prototype.renderComponents = function renderComponents() {
	    var modules = this.props.data.page.modules;
	
	
	    return modules.map(function (module, key) {
	      return _react2.default.createElement(_components2.default, _extends({
	        key: key
	      }, {
	        content: _extends({}, module)
	      }));
	    });
	  };
	
	  JobPage.prototype.componentDidMount = function componentDidMount() {
	    var search = this.props.location.search;
	
	    this.setState(function () {
	      return {
	        jobSlug: search.split('=').slice(-1).pop()
	      };
	    });
	  };
	
	  JobPage.prototype.render = function render() {
	    var jobSlug = this.state.jobSlug;
	
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_linkBack2.default, {
	        parent: {
	          slug: 'careers',
	          pageName: 'Careers'
	        }
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'section indented-contents gray-dividers' },
	        _react2.default.createElement('div', { className: 'mt-60' }),
	        jobSlug && _react2.default.createElement(_jobComponent2.default, {
	          jobSlug: jobSlug
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'section gray-dividers' },
	        this.renderComponents()
	      )
	    );
	  };
	
	  return JobPage;
	}(_react.PureComponent);
	
	exports.default = JobPage;
	var JobPageQuery = exports.JobPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-job-template-js-9861e20875fbfcb9bdd0.js